import { Koi } from '@ksyos/koi';
import type { IKisSettingAddEditValidated } from './kisSetting';
import type { ISchemaContainer } from './schemaContainer';
import { KisSettingEdit } from './kisSetting';
import { emailSchema } from './schemas/emailSchema';
import { agbCodeSchema } from './schemas/identifierDeclarationSchemas';
import { relationNumberSchema } from './schemas/relationNumberSchema';

export type GroupAddEditValidated = {
    financialEmailAddress?: string | null;
    identifierDeclaration?: string | null;
    isActive: boolean;
    kisSetting?: IKisSettingAddEditValidated;
    name: string;
    relationNumber?: string | null;
};

export const groupAddEditSchema: ISchemaContainer<GroupAddEditValidated> = {
    schema: Koi.object({
        financialEmailAddress: emailSchema.optional().allow(null),
        identifierDeclaration: agbCodeSchema.allow(null),
        isActive: Koi.boolean(),
        kisSetting: KisSettingEdit.optional(),
        name: Koi.string().max(255),
        relationNumber: relationNumberSchema,
    }).options({ convert: false, presence: 'required' }),
};

export interface IGroupFilters {
    relationNumber?: string;
    searchText?: string;
}

export const groupFiltersValidation = Koi.object({
    relationNumber: Koi.string().max(255),
    searchText: Koi.string().max(255),
});
